<template>
  <div>
    <h2 class="text-center text-space">
      El lote ha sido creado con éxito!
      <br />
      <small>Haga click en finalizar para ir al listado de lotes.</small>
    </h2>

    <div class="row m-5">
      <div v-if="producer" class="col-sm-4 border-left">
        <div>
          <p class="h5 m-0">Productor</p>
          <router-link
            v-if="$can('show', 'producers')"
            :to="{ name: 'ProducerShow', params: { id: producer.id } }"
            class="h5"
          >
            <p class="h3 text-primary">{{ producer.businessName }}</p>
          </router-link>
          <p v-else class="h3 text-primary">{{ producer.businessName }}</p>
        </div>
        <div>
          <p class="h5">CUIT</p>
          <p>{{ producer.cuit }}</p>
        </div>
        <div>
          <p class="h5">Email</p>
          <p>{{ producer.email }}</p>
        </div>
      </div>

      <div v-if="field" class="col-sm-4 border-left">
        <div>
          <p class="h5 m-0">Establecimiento</p>
          <router-link v-if="$can('show', 'fields')" :to="{ name: 'FieldShow', params: { id: field.id } }" class="h5">
            <p class="h3 text-danger">{{ field.name }}</p>
          </router-link>
          <p v-else class="h3 text-danger">{{ field.name }}</p>
        </div>
        <div>
          <p class="h5">Ubicación</p>
          <p>{{ field.city.name }}, {{ field.city.province.name }}</p>
        </div>
        <div>
          <p class="h5">Hectáreas</p>
          <p>{{ field.hectares }}&nbsp;has.</p>
        </div>
      </div>

      <div v-if="plot" class="col-sm-4 border-left">
        <div>
          <p class="h5 m-0">Lote</p>
          <router-link v-if="$can('show', 'plots')" :to="{ name: 'PlotShow', params: { id: plot.id } }" class="h5">
            <p class="h3 text-success">{{ plot.name }}</p>
          </router-link>
          <p v-else class="h3 text-success">{{ plot.name }}</p>
        </div>

        <div v-if="plot.latitude || plot.longitude" class="row mb-3">
          <div class="col-sm-12">
            <p class="h5">Coordenadas</p>
            <a target="_blank" :href="mapLink"> {{ plot.latitude }}°, {{ plot.longitude }}° </a>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="h5">Variedad</p>
            <p>{{ plot.variety.name }} ({{ plot.variety.crop.name }})</p>
          </div>
          <div class="col-sm-6">
            <p class="h5">Hectáreas</p>
            <p>{{ plot.hectares }}&nbsp;has.</p>
          </div>
        </div>

        <div v-if="plot.groovesDistance" class="row">
          <div class="col-sm-8">
            <p class="h5">Distancia entre surcos</p>
            <p>{{ plot.groovesDistance.toFixed(2) }}&nbsp;cm.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    producer: null,
    field: null,
    plot: null,
  },

  computed: {
    mapLink() {
      const params = `/@${this.plot.latitude},${this.plot.longitude},10z`;
      return this.$services.resource('maps').staticPlace(this.plot.latitude, this.plot.longitude) + params;
    },
  },
};
</script>
